/* Polsk katalog for locale-superplumma-workspace.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Pracuj z SuperPlummą na czacie i śledź zadanie w obszarze roboczym.',
  'spw.eyebrow': 'Twoja asystentka księgowa',
  'spw.intro': 'Co dziś robimy? Poproś mnie o utworzenie faktury albo prześlij dokument. Dokument będzie widoczny tutaj, gdy będziemy nad nim pracować.',
  'spw.upload': 'Prześlij dokument',
  'spw.camera': 'Zrób zdjęcie',
  'spw.dropHint': 'Możesz też upuścić dokument tutaj.',
  'spw.drop': 'Upuść dokument tutaj',
  'spw.uploading': 'Przesyłanie dokumentu …',
  'spw.uploadError': 'Nie udało się przesłać dokumentu.',
  'spw.saveDraft': 'Zapisz szkic',
  'spw.issued': 'Faktura została utworzona.',
  'spw.showProposal': 'Pokaż propozycję',
  'spw.editDetails': 'Zmień szczegóły',
  'spw.addReceipt': 'Prześlij dokument na czacie lub zrób zdjęcie.',
  'spw.proposal': 'Propozycja księgowania',
  'spw.supplierMissing': 'Nie wybrano dostawcy',
  'spw.account': 'Konto',
  'spw.vat': 'VAT',
  'spw.notSelected': 'Nie wybrano',
  'spw.readingHint': 'Propozycja pojawi się, gdy dokument zostanie odczytany lub szczegóły zostaną uzupełnione.',
  'spw.paymentAccount': 'Konto płatności',
  'spw.unpaid': 'Niezapłacone',
  'spw.approvalHint': 'Poproś SuperPlummę o zaksięgowanie, gdy propozycja będzie gotowa. Będziesz mógł sprawdzić i zatwierdzić działanie.',
  'spw.openTask': 'Otwórz zadanie',
  'spw.chat': 'Czat',
  'spw.workspace': 'Obszar roboczy',
  'spw.shared': 'Jedna księgowość. Pełny wgląd.',
  'spw.receipts': 'Księgowanie dokumentów',
  'spw.purchase': 'Zakupy',
  'spw.sale': 'Sprzedaż',
  'spw.invoice': 'Szkic faktury',
  'spw.choose': 'Wybierz zadanie',
  'spw.loading': 'Otwieranie obszaru roboczego …',
  'spw.loadError': 'Nie udało się wczytać obszaru roboczego. Twoja rozmowa została zachowana.',
  'spw.retry': 'Spróbuj ponownie',
  'spw.unavailable': 'Otwórz SuperPlummę w aktywnej firmie, aby zacząć.',
  'spw.changeTitle': 'Zmienić zadanie?',
  'spw.changeText': 'Zapisz ewentualne zmiany w formularzu przed zmianą zadania. Niezapisane zmiany mogą zostać utracone.',
  'spw.changeConfirm': 'Zmień zadanie',
});
